import ActivitiesScreen from './ActivitiesScreen'
export default ActivitiesScreen
